import axios from "axios";
import moment from "moment";
import Regex from "./Regex";
import * as loadImage from "blueimp-load-image";
import { country_code } from "./Constant";

const helpers = {
  /* Convert number to 2 decimal without round up */
  toFixedTwoWithoutRoundUp: (value, callback) => {
    let length = String(Number.parseFloat(value).toFixed(6)).length;

    return String(Number.parseFloat(value).toFixed(6)).substring(0, length - 4);
  },
  loadSecureImage: (url, callback) => {
    return axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          callback(reader.result);
        });
        reader.readAsDataURL(response.data);
      })
      .catch((error) => {
        return false;
      });
  },
  loadSecureFile: (url, callback) => {
    return axios
      .get(url, { responseType: "blob" })
      .then((response) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          callback(reader.result, response.data);
        });
        reader.readAsDataURL(response.data);
      })
      .catch((error) => {
        return false;
      });
  },
  generateTrackNo: (prefix) => {
    let text = "";
    let now = moment();
    let possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 16; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    let trackNo = prefix + text + now;

    return trackNo;
  },
  getPhoneNoMinLength: (code = "", type = "mobile") => {
    let minLength = 8;
    let selectedCode = country_code.find((x) => x.dial_code === code);

    if (selectedCode !== undefined) {
      if (type === "local") {
        minLength = selectedCode.localMinLength;
      } else {
        minLength = selectedCode.mobileMinLength;
      }
    }

    return minLength;
  },
  getPhoneNoMaxLength: (code = "", type = "mobile") => {
    let minLength = 11;
    let selectedCode = country_code.find((x) => x.dial_code === code);

    if (selectedCode !== undefined) {
      if (type === "local") {
        minLength = selectedCode.mobileMaxLength;
      } else {
        minLength = selectedCode.mobileMaxLength;
      }
    }

    return minLength;
  },
  validatePhoneWithCountryCode: (phoneNo, country_code = "") => {
    let type = "phoneNo";
    switch (country_code) {
      case "+65":
        type = "phoneNoSG";
        break;
      default:
        break;
    }
    let valid = Regex[type].test(phoneNo);

    return valid;
  },
  loadImageWithRotation: (file, orientation = true) => {
    return new Promise((resolve, reject) => {
      loadImage(
        file,
        async (canvas) => {
          const imageBaseURL = canvas.toDataURL();
          const newFile = await helpers.convertCanvasToBlob(canvas, file);

          let data = {
            file: newFile,
            image: imageBaseURL,
          };
          resolve(data);
        },
        { orientation: orientation }
      );
    });
  },
  convertCanvasToBlob: (canvas, file) => {
    let fileName = "image";
    let fileType = "image/jpeg";

    if (file) {
      fileName = file.name;
      fileType = file.type;
    }

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        blob.name = fileName;
        const file = new File([blob], fileName, {
          type: fileType,
        });
        resolve(file);
      }, "image/jpeg");
    });
  },
};

export default helpers;
